var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"show-destop"},[_c('nav-bar-faq'),_c('div',{staticClass:"container-fluid",attrs:{"id":"mainContent"}},[_c('router-view')],1),_c('footer-element')],1),_c('mobile-download-app')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }